/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionSetData
 */
export interface PermissionSetData {
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionSetData
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PermissionSetData
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof PermissionSetData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PermissionSetData
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof PermissionSetData
     */
    context?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionSetData
     */
    hasNext?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionSetData
     */
    hasPrevious?: boolean;
}

/**
 * Check if a given object implements the PermissionSetData interface.
 */
export function instanceOfPermissionSetData(value: object): value is PermissionSetData {
    return true;
}

export function PermissionSetDataFromJSON(json: any): PermissionSetData {
    return PermissionSetDataFromJSONTyped(json, false);
}

export function PermissionSetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSetData {
    if (json == null) {
        return json;
    }
    return {
        
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['page_size'] == null ? undefined : json['page_size'],
        'context': json['context'] == null ? undefined : json['context'],
        'hasNext': json['has_next'] == null ? undefined : json['has_next'],
        'hasPrevious': json['has_previous'] == null ? undefined : json['has_previous'],
    };
}

export function PermissionSetDataToJSON(json: any): PermissionSetData {
    return PermissionSetDataToJSONTyped(json, false);
}

export function PermissionSetDataToJSONTyped(value?: PermissionSetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissions': value['permissions'],
        'total': value['total'],
        'page': value['page'],
        'page_size': value['pageSize'],
        'context': value['context'],
        'has_next': value['hasNext'],
        'has_previous': value['hasPrevious'],
    };
}

